import { useMemo } from "react";
import { FollowersByCountry } from "../../types";
import CountriesPresenter from "./CountriesPresenter";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { useTotalFollowers } from "../../api/social";
import { useSocialFollowerArtistFilter } from "@arelia-hooks/artistAccount";

export default function CountriesContainer() {
  const requiredConnectionNames = [ConnectionName.instagram, ConnectionName.facebook];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);

  const { data = [], isLoading, isError } = useTotalFollowers({ enabled: hasRequiredConnections });
  const filteredData = useSocialFollowerArtistFilter(data);

  const countries = useMemo<FollowersByCountry[]>(() => {
    return filteredData
      .filter((f) => f.networkName !== ConnectionName.youtube)
      .map((f) => {
        return {
          networkName: f.networkName,
          byCountry: f.byCountry || {},
          totalByCountry: (f.byCountry && Object.values(f.byCountry).reduce((acc, country) => acc + country, 0)) || 0,
        }
      })
  }, [filteredData]);

  return (
    <CountriesPresenter
      countries={countries}
      loading={isLoading}
      error={isError}
      unconnected={!hasRequiredConnections}
      id="SOCIAL_COUNTRIES"
    />
  );
}
